import { createFileRoute, redirect } from '@tanstack/react-router'
import { useAuthStore } from '@/features/auth'
import { AuditLogsPage } from '@/features/audit-logs'

export const Route = createFileRoute('/_authenticated/admin/audit-logs/')({
  beforeLoad: () => {
    const { auth } = useAuthStore.getState()
    if (auth.user?.role !== 'admin' && auth.user?.role !== 'super_admin') {
      throw redirect({ to: '/403' })
    }
  },
  component: AuditLogsPage,
})
